import { Component, OnInit , Inject} from '@angular/core';
import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { PrintdaybookService } from "../../print/printdaybook.service";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToasterserviceService } from "../../../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../../../utility/shared/toastpayload";

@Component({
  selector: 'app-rptdaybookcentrepopup',
  templateUrl: './rptdaybookcentrepopup.component.html',
  styleUrls: ['./rptdaybookcentrepopup.component.css']
})

export class RptdaybookcentrepopupComponent implements OnInit {

  BranchList: any[] = [];
  CentreList: any[] = [];
  toast : Toastpayload;

  constructor(private commonmastersService: CommonmastersService,
    private printdaybookService: PrintdaybookService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RptdaybookcentrepopupComponent>,
    private toasterserviceService: ToasterserviceService,) { }

  ngOnInit() {
    // this.GetBranchList();
    this.GetBranch();
    this.data.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
  }

  // GetBranchList() {
  //   this.commonmastersService.GetBranchList().subscribe(data => {
  //     this.BranchList = data;
  //   })
  // }

  GetBranch() {
    this.commonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;

      // data.BranchId = 0;
      this.data.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];

      //auto selecting the centre based on branch selected.
      this.CentreList = [];
      this.SelectCentre(this.data.BranchId);
    })
  }

  SelectCentre(branchId: any) {
    this.commonmastersService.FetchCentersBybranchId(branchId).subscribe(data => {
      this.CentreList = data;
    })
  }

  GenerateReports(): void {
    
    this.data.ReportName = "DaybookCentreReport";    
    this.printdaybookService.GenerateReport(this.data);
    this.dialogRef.close();

    // toastr Notification
    this.toast = {
      message: "Please wait, the report is loading in the new tab!",
      title: 'Report', 
      ic:  {
        timeOut: 8000,
        closeButton: true,
      } as IndividualConfig,
      type: 'info',    
    };

    // this.toast.type = 'info';
    this.toasterserviceService.showToast(this.toast);
  }

}
